export default __webpack_public_path__ + "static/media/ILPlatform_Programme5-7.b6370aaa.webp";